<template>
  <b-modal ok-only size="lg" id="customer-files" title="Customer Files" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" @hidden="resetData">
       <section class="order-properties">
         <h4 class="m-b-30">Order no: <b-badge variant="success" class="badge-custom">{{order_no}}</b-badge></h4>
        <div v-for="item in items" v-bind:key="item.id" class="m-b-20">
            <h3 class="m-b-20">Order Item Name: {{item.name}}</h3>
            <ul v-for="(property, index) in item.properties" v-bind:key="index">
                <li>
                    
                    <div v-if="property.name.includes('uploadery')">
                      <a :href="property.value" download >
                        <b-img-lazy center thumbnail  :src="`${getBase(property.value)}preview_${property.value.split('/').pop()}`" alt="Customer Image"></b-img-lazy>
                      </a>
                       <div class="text-center">
                        {{property.width}}px  <span class="text-danger">X</span> {{property.height}}px
                      </div>
                    </div>
                    
                    <span v-else>Note: {{ property.value }}</span>
                    
                </li>
            </ul>
           
        </div>
       </section>
      <div>
         <b-button variant="outline-primary" class="m-b-10" @click="fetchCustomerOrderHistory()">Show Customer Order History</b-button>
         <section>
          <div class="text-center" v-if="processing">
            <b-spinner variant="primary" label="Spinning" ></b-spinner>
          </div>
           <div role="tablist" v-else>

              <b-card no-body class="mb-1" v-for="order in customerOrderHistory" v-bind:key="order.id">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle="'accordion-' + order.id" variant="primary" size="lg"><h5>
                    Order No: {{order.order_no}}
                  </h5></b-button>
                </b-card-header>
                <b-collapse :id="'accordion-' + order.id"  accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    
                    <div v-for="item in order.ShopifyOrderItems" v-bind:key="item.id">
                        <h3>{{ item.name}}</h3>
                        <div>
                          <div v-for="(property, index) in item.properties" v-bind:key="index">
                              <div v-if="property.name.includes('uploadery')" class="m-b-20"> 
                                <a :href="property.value" download :title="property.name">
                                  <b-img-lazy thumbnail  :src="`${getBase(property.value)}preview_${property.value.split('/').pop()}`" alt="Customer Image"></b-img-lazy>
                                </a>
                              </div>
                              <div v-else>
                                <strong>{{ property.name }} :</strong> {{ property.value}}
                              </div>
                          </div>
                        </div>
                    </div>
                    
                  </b-card-body>
                </b-collapse>
              </b-card>

           </div>

         </section>
      </div>
  </b-modal>
</template>

<script>
 import EventBus from '../../EventBus';
import OrdersService from '../../services/orders.service';

  export default {
     data(){
       return {
         items: [],
         order_no: '',
         headerBgVariant: 'dark',
         headerTextVariant: 'light',
         customerOrderHistory: [],
         processing:false
       }
     },
     mounted(){
        EventBus.$on('customer-files-modal-opened', ({items, order_no}) => {
          
          this.items = items; 
          this.order_no= order_no;
          
          this.items.forEach((item, index1) => {
             item.properties.forEach((property, index2) => {
                  if(property.name.includes('uploadery')){
                     this.$set(this.items[index1].properties[index2], 'width', '...');
                     this.$set(this.items[index1].properties[index2], 'height', '...');
                     this.getDimensionInfo(property, index1, index2);
                  }
              })
            })


          })
     },
     methods: {
       getBase(path){
         let basePath = path.split('/');
         basePath.pop()
         return basePath.join('/') + '/';
       },
       getDimensionInfo(property, index1, index2){
         console.log('Calculating widht and height of image')
         let img = new Image();

          img.onload = () => {
             this.items[index1].properties[index2].width = img.width;
             this.items[index1].properties[index2].height = img.height;
          }

          img.src = property.value;

       },
       async fetchCustomerOrderHistory(){

           this.processing = true;
           const orderId = this.items[0].shopify_order_id;
           
           const result = await OrdersService.fetchCustomerOrdersHistory(orderId);

           this.customerOrderHistory = result.data.history;
           this.processing = false;
           
       },
       resetData(){
         this.customerOrderHistory = []  
       }
     }
  }
</script>

<style lang="scss" scoped>
  .badge-custom{
     font-size: inherit;
  }
  ul{
    list-style-type: none;
    padding-left: 0;
    li{
      width: 200px;
      display: inline-block;
    }
  }
</style>